
<template>
  <v-card>
    <v-progress-linear style="margin : 0 auto ; height:10px" indeterminate v-if="isLoading"></v-progress-linear>
    <v-btn @click="backTodisciplinList" class="mx-2" fab dark color="primary">
      <v-icon dark>arrow_back</v-icon>
    </v-btn>
    <v-card-title>
      Lista dos Estudantes na turma {{ this.$store.state.objturma.pkTurma }}

      <v-chip v-if="true" class="ma-2" close color="pink" label outlined>
        {{ (!this.$store.state.fromMinhaTurmas) ? this.$store.state.objturma.turmadescricao : this.$store.state.objturma.descricao }}
      </v-chip>
      <v-spacer></v-spacer>
      <span>Selecionado : <strong style="font-size:22px;">{{ $store.state.anolectivoSelecionado }}</strong></span>
      <v-spacer></v-spacer>
    </v-card-title>
    <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
      {{ $store.state.textMessage }}
    </div>
    <v-data-table :headers="headers" :items="listEstudantfromPauta" :items-per-page="50" class="elevation-1">

      <template v-slot:item.action="{ item }">
        <v-menu bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-btn fab dark color="teal" style="color:white" v-on="on">
              <v-icon>menu</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="openDialog(item)"> <v-icon color="red">swap_horiz</v-icon> <span style="color:red;">
                -Mudar de turma</span></v-list-item>
            <v-list-item @click="openDialogEliminar(item)" v-if="false"> <v-icon color="red">delete</v-icon> <span
                style="color:red;"> -Eliminar matricula</span></v-list-item>

          </v-list>
        </v-menu>

        <!--<v-img  style="color:green" src="../assets/boletim.jpg" width="80px"  class="mr-2" @click="editItem(item)"></v-img>-->
      </template>
      ></v-data-table>

    <!--======================================= MODAL==========Mudar Turma-Curso =======================================-->

    <v-dialog v-model="dialogo_turma" max-width="500">
      <v-card>
        <v-card-title class="headline"><v-icon color="blue">info</v-icon>Mudança de Turma</v-card-title>

        <v-card-text>
          <v-row>

            <v-col cols="6">
              <v-text-field v-model="editedItem_mudar_classe.nome" label="Nome do estudante" disabled></v-text-field>
            </v-col>
            <!-- <v-col cols="6">
              <v-select v-model="editedItem_mudar_classe.anoLectivo" :items="Listaranoslectivo" item-value="idAnoLectivo"
                item-text="descricao" @change="initializeturmasAllAnolectivo()" label="Ano Lectivo"
                return-object></v-select>
            </v-col> -->
            <v-col cols="6">
              <v-text-field v-model="editedItem_mudar_classe.turma" label="Turma Actual" disabled></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select v-model="turma_selecionada" :items="turmasFiltered" item-value="pkTurma" @change="verifyQuantity()"
                item-text="turmadescricao" label="Nova Turma" return-object></v-select>
            </v-col>
            <v-col cols="6">
              <v-progress-circular v-if="progresso" indeterminate color="green"></v-progress-circular>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="dialogo_turma = false">
            Cancelar
          </v-btn>

          <v-btn color="green darken-1" text :disabled="!turma_selecionada" @click="Mudar_Turma()">
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ===================================== FIM DO MODAL ================================-->
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog_confirmar" max-width="490">
          <v-card>
            <v-card-title class="headline">Eliminar confirmação de matricula</v-card-title>
            <v-card-text>Tem a certeza que pretente continuar com operação ? </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="dialog_confirmar = false">Cancelar</v-btn>
              <v-btn color="green darken-1" text @click="eliminarConfirmacaoMatricula()">Continuar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-card>
</template>

<script>
import axios from '../../plugins/axios'
import Swal from 'sweetalert2'
export default {
  data: () => ({
    dialog_confirmar: false,
    Listaranoslectivo: [],
    dialogo_turma: false,
    progresso: false,
    isLoading: false,
    turmasAll: [],
    turmasAllAnoLectivo: [],
    text: '',
    editedItem_mudar_classe: {
      nome: '',
      anoLectivo: '',
      turma: ''
    },
    turmasFiltered: [],
    listEstudantfromPauta: [],
    turma_selecionada: null,
    headers: [
      {
        text: 'Nome',
        align: 'start',
        sortable: false,
        value: 'nome'
      },
      { text: 'Matricula', value: 'idMAtricula' },
      { text: 'Resultado', value: 'resultado' },
      { text: 'Operações permitidas', value: 'action', sortable: false }

    ]

  }),
  computed: {

    idclasse() {
      return this.$store.state.idclasse
    }
  },
  created() {
    this.initializeturmasAllAnolectivo()
    this.pautaByTurma()
  },

  methods: {
    backTodisciplinList() {
      if (!this.$store.state.fromMinhaTurmas) { this.$router.push('PainelClassMudarTurma') } else { this.$router.push('minhas-turmas') }
    },
    async initializeturmasAllAnolectivo() {
      this.turma_selecionada = null
      this.turmasFiltered = []
      this.isLoading = true
      try {
        this.turmasAllAnoLectivo = await axios
          .get('/obterturmasQuantEstudantes/' + this.$store.state.objturma.anoLectivo)
          .then(res => res.data)
        this.turmasFiltered = this.turmasAllAnoLectivo.filter(t => t.idCurso == this.$store.state.objturma.idCurso && t.idAno_Academico == this.$store.state.objturma.idAno_Academico)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        Swal.fire({ icon: 'error',title: 'Informação!', text: 'Ocorreu um erro ao carregar as turmas'})
      }
    },
    verifyQuantity(){
      if(this.turma_selecionada.capacidade <= this.turma_selecionada.numeroestudantes){
        Swal.fire({ icon: 'warning',title: 'Informação!', text: 'Turma cheia, por favor selecione uma outra'}) 
        this.turma_selecionada = null
      }
             
    },
    async pautaByTurma() {
      this.isLoading = true

      try {
        this.listEstudantfromPauta = await axios
          .get('/ListaEstudantes/' + this.$store.state.objturma.pkTurma)
          .then(res => res.data)
        if (!this.listEstudantfromPauta.length) Swal.fire({ icon: 'warning',title: 'Informação!', text: 'Turma vazia'})
          this.isLoading = false
      } catch (error) {
        this.isLoading = false
        Swal.fire({ icon: 'error',title: 'Informação!', text: 'Ocorreu um erro ao listar alunos'})
      }
    },



    openDialog(item) {
      this.dialogo_turma = true
      this.editedItem_mudar_classe = item
    },
    


    async Mudar_Turma() {
      // this.progresso = true
      let dados = {
        matricula: this.editedItem_mudar_classe.idMAtricula,
        pkTurma: this.turma_selecionada.pkturma,
        idAnoLectivo: this.$store.state.objturma.idAnoLectivo,
        idTurma: this.turma_selecionada.idTurma,
        anolectivo: this.turma_selecionada.anoLectivo,
        idAnoAcademico: this.turma_selecionada.idAno_Academico,
        pkInscricao_na_turma: this.editedItem_mudar_classe.pkInscricao_na_turma
      }
      
      try {
        let msg = await axios
          .post('/mudarTurma_', dados)
          .then(res => res.data)
          this.turma_selecionada = null
        this.progresso = false
        Swal.fire({ icon: 'success',title: 'Informação!', text: 'Mudança feita com sucesso'})
        this.pautaByTurma()
        this.progresso = false
        this.dialogo_turma = false
      } catch (error) {
        this.progresso = false
        this.dialogo_turma = false
        Swal.fire({ icon: 'error',title: 'Informação!', text: 'Ocorreu um erro ao realizar essa operação'})
      }
    },
    openDialogEliminar(item) {
      this.editedItem_mudar_classe = item
      this.dialog_confirmar = true
    },
    async eliminarConfirmacaoMatricula() {
      this.dialog_confirmar = false
      this.progresso = true
      let dados = {
        pkInscricao_na_turma: this.editedItem_mudar_classe.pkInscricao_na_turma
      }
      try {
        let msg = await axios
          .post('/eliminarConfirmacaoMatricula', dados)
          .then(res => res.data)
        this.progresso = false
        this.text = msg
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 4000 })
        this.pautaByTurma()
        this.progresso = false
        this.dialogo_turma = false
      } catch (error) {
        this.progresso = false
        this.dialogo_turma = false
      }
    }

  }
}
</script>
